import { root, id } from './fts';

export const fts = {
  ...root,
  id,
};
